import { render } from "./DepartureFrom.vue?vue&type=template&id=47de35d0&scoped=true"
import script from "./DepartureFrom.vue?vue&type=script&lang=js"
export * from "./DepartureFrom.vue?vue&type=script&lang=js"

import "./DepartureFrom.vue?vue&type=style&index=0&id=47de35d0&scoped=true&lang=css"

import exportComponent from "D:\\VueLearning\\SheepbaseVueJs\\SheepBaseVueApp\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-47de35d0"]])

export default __exports__